/**
 * Capitalizes the first letter of a string and replaces hyphens or underscores with spaces.
 * @param {string} s - The input string to be capitalized and formatted.
 * @returns {string} The formatted string with the first letter capitalized and hyphens/underscores replaced with spaces.
 */
export default function capitalizeFirstLetter(s = '') {
  return (s.charAt(0).toUpperCase() + s.slice(1)).replace(/-|_/, ' ');
}